import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsWalkNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.545 3c.635 0 1.257.184 1.79.529l2.487 1.611.005-.007.478.32 3.12 1.425A2.697 2.697 0 0116 9.331V9.357c-.004.11-.05.787-.638 1.44-.603.67-1.673 1.203-3.507 1.203H1.52a1.52 1.52 0 01-.843-2.786l.101-.067A.498.498 0 001 8.733v-4.3c0-.584.474-1.058 1.058-1.058.478 0 .926.228 1.207.614l.553.761h.942l-.344-.902A.625.625 0 015 3zm3.584 3.18l-.58-.376-.709 1.063-1.04-.694.699-1.048-.844-.547a2.042 2.042 0 00-1.11-.328h-.638L6.574 6H3.182l-.928-1.275-.004-.006V8.75H12c.417 0 .675-.192 1.102-.545l.031-.025c.123-.102.262-.216.42-.326L11.223 6.79l-.717 1.077-1.04-.694zm4.474 2.516c-.224.085-.43.246-.705.474l-.031.025C13.462 9.53 12.893 10 12 10H1.706c-.072.068-.15.13-.234.187l-.102.067a.27.27 0 00.15.496h10.335c1.588 0 2.276-.454 2.578-.79.273-.302.312-.599.317-.644a1.443 1.443 0 00-.147-.62z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWalkNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsWalkNormalXsmall;
